import {
  DISPLAY_STYLE_HEADER,
  DISPLAY_STYLE_PREVENT_DISABLE_STYLE
} from "components/Shared/MGridForm";
import {
  DATA_TYPE_STRING,
  DATA_TYPE_RADIO,
  DATA_TYPE_MULTI_LINE_STRING,
  DATA_TYPE_DATE,
  DATA_TYPE_SPLIT_RADIO,
  DATA_TYPE_CHECKBOX
} from "typeConstants/dataTypes";

export default [
  [
    { label: "The purpose of this report form is to provide the lender/client with an accurate update of an appraisal and/or to report a certification of completion. The appraiser must identify the service(s) provided by selecting the appropriate report type." }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Property Address", source: "D-1", width: 70 },
    { dataType: DATA_TYPE_STRING, label: "Unit #", source: "D-2" },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "City", source: "D-3", width: 50 },
    { dataType: DATA_TYPE_STRING, label: "State", source: "D-4", width: 20 },
    { dataType: DATA_TYPE_STRING, label: "Zip Code", source: "D-5" },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Legal Description", source: "D-6", width: 70 },
    { dataType: DATA_TYPE_STRING, label: "County", source: "D-7" },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Borrower", source: "D-8", width: 30 },
    { dataType: DATA_TYPE_STRING, label: "Contract Price $", source: "D-9", width: 20 },
    { dataType: DATA_TYPE_DATE, label: "Date of Contract", source: "D-10", width: 20 },
    { dataType: DATA_TYPE_DATE, label: "Effective Date of Original Appraisal", source: "D-11" },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Property Rights Appraised", source: "D-12|D-13|D-14", width: 42,
      dataTypeOptions: {
        options: [{ label: "Fee Simple", value: "Fee Simple" }, { label: "Leasehold", value: "Leasehold" }, { label: "Other (describe)", value: "Other" }]
      }
    },
    { dataType: DATA_TYPE_STRING, source: "D-15", width: 28 },
    { dataType: DATA_TYPE_STRING, label: "Original Appraised Value $", source: "D-16" }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Original Appraiser", source: "D-17", width: 50 },
    { dataType: DATA_TYPE_STRING, label: "Company Name", source: "D-18" }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Original Lender/Client", source: "D-19", width: 50 },
    { dataType: DATA_TYPE_STRING, label: "Address", source: "D-20" }
  ],
  [
    { label: "SUMMARY APPRAISAL UPDATE REPORT", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { dataType: DATA_TYPE_CHECKBOX, label: "Summary appraisal update report", source: "D-21" },
  ],
  [
    { label: "INTENDED USE: The intended use of this appraisal update is for the lender/client to evaluate the property that is the subject of this report to determine if the property has declined in value since the date of the original appraisal for a mortgage finance transaction." }
  ],
  [
    { label: "INTENDED USER:  The intended user of this appraisal update is the lender/client." }
  ],
  [
    { label: "SCOPE OF WORK:  The appraiser must, at a minimum: (1) concur with the original appraisal, (2) perform an exterior inspection of the subject property from at least the street, and (3) research, verify, and analyze current market data in order to determine if the property has declined in value since the effective date of the original appraisal.", style: { borderBottom: 3 } }
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "HAS THE MARKET VALUE OF THE SUBJECT PROPERTY DECLINED SINCE THE EFFECTIVE DATE OF THE ORIGINAL APPRAISAL?", source: "D-22|D-23",
      dataTypeOptions: {
        options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }]
      }, style: { borderBottom: 0 }
    }
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "D-24-1|D-24-2|D-24-3", style: { borderBottom: 3 } },
  ],
  [
    { label: "APPRAISER’S CERTIFICATION:  The appraiser certifies and agrees that:", style: { borderBottom: 0 } }
  ],
  [
    { label: "1.", width: 2, style: { borderBottom: 0 } },
    {
      label: "I have, at a minimum, developed and reported this appraisal update in accordance with the scope of work requirements stated in this appraisal update report and concur with the analysis and conclusions in the original appraisal."
      , style: { borderBottom: 0 }
    }
  ],
  [
    { label: "2.", width: 2, style: { borderBottom: 0 } },
    {
      label: "I performed this appraisal update in accordance with the requirements of the Uniform Standards of Professional Appraisal Practice that were adopted and promulgated by the Appraisal Standards Board of The Appraisal Foundation and that were in place at the time this appraisal update was prepared."
      , style: { borderBottom: 0 }
    }
  ],
  [
    { label: "3.", width: 2, style: { borderBottom: 0 } },
    {
      label: "I have updated the appraisal by incorporating the original appraisal report."
      , style: { borderBottom: 0 }
    }
  ],
  [
    { label: "4.", width: 2, style: { borderBottom: 3 } },
    {
      label: "I have summarized my analysis and conclusions in this appraisal update and retained all supporting data in my work file."
      , style: { borderBottom: 3 }
    }
  ],
  [
    { label: "SUPERVISORY APPRAISER’S CERTIFICATION: The Supervisory Appraiser certifies and agrees that:", style: { borderBottom: 0 } }
  ],
  [
    { label: "1.", width: 2, style: { borderBottom: 0 } },
    {
      label: "I directly supervised the appraiser for this appraisal update assignment, have read the appraisal update report, and agree with the appraiser’s analysis,  opinions, statements, conclusions, and the appraiser’s certification."
      , style: { borderBottom: 0 }
    }
  ],
  [
    { label: "2.", width: 2, style: { borderBottom: 3 } },
    {
      label: "I accept full responsibility for the contents of this appraisal update report including, but not limited to, the appraiser’s analysis, opinions, statements, conclusions, and the appraiser’s certification."
      , style: { borderBottom: 3 }
    }
  ],
  [
    { label: "CERTIFICATION OF COMPLETION", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { dataType: DATA_TYPE_CHECKBOX, label: "Certification of completion", source: "D-27" },
  ],
  [
    { label: "INTENDED USE:  The intended use of this certification of completion is for the lender/client to confirm that the requirements or conditions stated in the appraisal report referenced above have been met." }
  ],
  [
    { label: "INTENDED USER:  The intended user of this certification of completion is the lender/client." }
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "HAVE THE IMPROVEMENTS BEEN COMPLETED IN ACCORDANCE WITH THE REQUIREMENTS AND CONDITIONS STATED IN THE ORIGINAL APPRAISAL REPORT?", source: "D-28|D-29",
      dataTypeOptions: {
        options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }]
      }, style: { borderBottom: 0 }
    },
  ],
  [{
    dataType: DATA_TYPE_MULTI_LINE_STRING, source: "D-65-1|D-65-2", style: { borderBottom: 0, className: DISPLAY_STYLE_PREVENT_DISABLE_STYLE }, enabled: () => false
  }],
  [
    {
      label: "If no, describe any impact on the opinion of market value", style: { borderBottom: 0 }
    }
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "D-30-1|D-30-2|D-30-3", style: { borderBottom: 3 } },
  ],
  [
    { label: "APPRAISER’S CERTIFICATION:  I certify that I have performed a visual inspection of the subject property to determine if the conditions or requirements stated in the original appraisal have been satisfied." }
  ],
  [
    { label: "SUPERVISORY APPRAISER’S CERTIFICATION: I accept full responsibility for this certification of completion." }
  ],
  [
    { label: "SIGNATURES", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    {
      label: "ADDITIONAL CERTIFICATION: I/we certify that if this report was transmitted as an “electronic record” containing my “electronic signature,” as those terms are defined in applicable federal and/or state laws (excluding audio and video recordings), or a facsimile transmission of this report containing a copy or representation of my signature, the report shall be as effective, enforceable and valid as if a paper version of this appraisal report were delivered containing my original hand written signature."
      , style: { borderBottom: 3 }
    }
  ],
  [
    {
      label: "APPRAISER", width: 50
      , style: { borderBottom: 0 }
    },
    {
      label: "SUPERVISORY APPRAISER (ONLY IF REQUIRED)"
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_CHECKBOX, label: "I agree to the use of my electronic signature", source: "D-appraiser-sig",
      style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_CHECKBOX, label: "I agree to the use of my electronic signature", source: "D-appraiser-supervisor-sig",
      style: { borderBottom: 0 }
    },
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "Name", source: "D-34", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_STRING, label: "Name", source: "D-48"
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "Company Name", source: "D-35", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_STRING, label: "Company Name", source: "D-49"
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "Company Address", source: "D-36", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_STRING, label: "Company Address", source: "D-50"
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "Telephone Number", source: "D-37", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_STRING, label: "Telephone Number", source: "D-51"
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_DATE, label: "Date of Signature and Report", source: "D-38", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_DATE, label: "Date of Signature", source: "D-52"
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_DATE, label: "Effective Date of Appraisal Update", source: "D-39", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_STRING, label: "State Certification #", source: "D-53"
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_DATE, label: "Date of Inspection", source: "D-40", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_STRING, label: "or State License #", source: "D-54"
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "State Certification #", source: "D-41", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_STRING, label: "State", source: "D-55"
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "or State License #", source: "D-42", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_DATE, label: "Expiration Date of Certification or License", source: "D-56"
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "or Other (describe)", source: "D-43", width: 30
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_STRING, label: "State #", source: "D-44", width: 20
      , style: { borderBottom: 0 }
    }
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "State", source: "D-45", width: 50
      , style: { borderBottom: 0 }
    },
    { label: "SUPERVISORY APPRAISER", style: { borderBottom: 0 } }
  ],
  [
    {
      dataType: DATA_TYPE_DATE, label: "Expiration Date of Certification or License", source: "D-46", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_SPLIT_RADIO, source: "D-60|D-61|D-62", label: "Did not inspect subject property", value: "Did not inspect subject property", style: { borderBottom: 0 }
    },
  ],
  [
    { label: "CURRENT LENDER/CLIENT", width: 50, style: { borderBottom: 0 } },
    {
      dataType: DATA_TYPE_SPLIT_RADIO, source: "D-60|D-61|D-62", label: "Did inspect exterior of subject property from street", value: "Did inspect exterior of subject property from street",
      style: { borderBottom: 0 }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Name", source: "D-57", width: 50, style: { borderBottom: 0 } },
    { width: 1.85, style: { borderBottom: 0 } },
    { dataType: DATA_TYPE_STRING, label: "Date of inspection", style: { borderBottom: 0 } },
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "Company Name", source: "D-58", width: 50
      , style: { borderBottom: 0 }
    },
    {
      dataType: DATA_TYPE_SPLIT_RADIO, source: "D-60|D-61|D-62", label: "Did inspect interior and exterior of subject property", value: "Did inspect interior and exterior of subject property"
      , style: { borderBottom: 0 }
    },
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "Company Address", source: "D-59", width: 50
      , style: { borderBottom: 0 }
    },
    { width: 1.85, style: { borderBottom: 0 } },
    {
      dataType: DATA_TYPE_DATE, label: "Date of Inspection", source: "D-63"
      , style: { borderBottom: 0 }
    },
  ],
];
